import { Button, Dialog, DialogContent, Avatar } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { ApiRequest } from 'GlobalFunctions';
import { PiCheckCircle } from "react-icons/pi";


export default function ResumeSubscriptionDialog(props: any) {
    const { 
        open, 
        setOpen, 
        loading,
        subscription_id,
        next_billing_date,
        loadSubscriptionDetails
    } = props;

    const submitResumeSubscription = () => {
        ApiRequest({
            url: '/subscriptions/resume',
            method: 'POST',
            body: {
                subscription_id: subscription_id
            },
            setResponse: (response: any) => {
                setOpen(false);
                if (loadSubscriptionDetails) {
                    loadSubscriptionDetails();
                }
            }
        });
    }

    const formatDate = (dateString: string) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', { 
            month: 'short', 
            day: 'numeric', 
            year: 'numeric',
            timeZone: 'UTC'
        });
    };

    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
        >
            <DialogContent style={{ padding: '0', maxWidth: '530px' }}>
                <div className="cancel_dialog_content" style={{ padding: '60px 60px 30px 60px'}}>
                    <div className="cancel_dialog_header">
                        <Avatar sx={{ bgcolor: '#E8F5E9', width: 40, height: 40 }}>
                            <PiCheckCircle color="#4CAF50" size={20} />
                        </Avatar>
                        <h3 className='heading_h3_dialog'>Resume Subscription</h3>
                    </div>

                    <p style={{ 
                        fontSize: '14px', 
                        color: '#666666', 
                        marginBottom: '50px',
                        lineHeight: '1.5',
                        textAlign: 'center'
                    }}>
                        Proceeding will remove the cancellation. The subscription remains active and will auto-renew on {formatDate(next_billing_date)}.
                    </p>
                </div>

                <div className="cancel_subs_dialog_actions">
                    <Button
                        variant="text"
                        color="primary"
                        onClick={() => setOpen(false)}
                        sx={{
                            borderColor: '#B9B9B9',
                            borderRadius: '5px !important',
                            color: '#424242',
                            padding: '6px 10px !important',
                            marginRight: '10px'
                        }}
                    >
                        Cancel
                    </Button>
                    <LoadingButton
                        variant="contained"
                        color="primary"
                        onClick={submitResumeSubscription}
                        loading={loading}
                        sx={{
                            padding: '6px 10px !important',
                        }}
                    >
                        Confirm
                    </LoadingButton>
                </div>
            </DialogContent>
        </Dialog>
    )
}
